// ============================================================
// bankSoalSubstitusi.js — Bank Soal Tes Substitusi Simbol
// Modul baru (bukan bagian dari 8 modul resmi yang sudah ada).
// Format: kunci 10 pasangan simbol-abstrak <-> kode-sederhana
// selalu tampil di layar. User mencocokkan simbol yang muncul
// dengan kode yang tepat, secepat & seteliti mungkin dalam waktu
// terbatas (persis konsep "digit-symbol substitution test" yang
// umum dipakai psikotes, versi digital: pilih kode dari 10 tombol,
// bukan menulis tangan).
// Semua simbol & kode ORISINAL buatan sendiri (bukan diekstrak
// dari file manapun) — jadi jawaban dijamin benar berdasarkan
// kunci yang saya definisikan sendiri, bukan tebakan.
// ============================================================

function svgWrap(content, bg = '#F8FAFC') {
  return `<svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><rect width="80" height="80" fill="${bg}" rx="8"/>${content}</svg>`;
}

// 10 pasangan kunci: simbol abstrak <-> kode sederhana. Urutan (a-j)
// ini yang dipakai untuk menampilkan strip kunci di layar tes.
export const kunciSimbol = [
  {
    id: 'a',
    simbol: svgWrap(`<path d="M30,55 Q30,25 55,30" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round"/>`),
    kode: svgWrap(`<path d="M40,22 v36 M22,40 h36" stroke="#B91C1C" stroke-width="5" stroke-linecap="round"/>`),
  },
  {
    id: 'b',
    simbol: svgWrap(`<path d="M20,45 Q30,25 40,45 T60,45" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round"/>`),
    kode: svgWrap(`<circle cx="40" cy="40" r="18" fill="none" stroke="#1D4ED8" stroke-width="5"/>`),
  },
  {
    id: 'c',
    simbol: svgWrap(`<path d="M50,20 H30 V40 H50 M30,40 V60 H50" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`),
    kode: svgWrap(`<rect x="23" y="23" width="34" height="34" fill="none" stroke="#047857" stroke-width="5"/>`),
  },
  {
    id: 'd',
    simbol: svgWrap(`<polygon points="40,18 58,55 22,55" fill="none" stroke="#1F2937" stroke-width="3" stroke-linejoin="round"/>`),
    kode: svgWrap(`<path d="M25,25 L55,55 M55,25 L25,55" stroke="#B45309" stroke-width="5" stroke-linecap="round"/>`),
  },
  {
    id: 'e',
    simbol: svgWrap(`<path d="M25,50 Q25,20 45,25 Q60,30 45,42 Q35,48 25,50" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round"/>`),
    kode: svgWrap(`<polygon points="40,20 58,56 22,56" fill="none" stroke="#6D28D9" stroke-width="5" stroke-linejoin="round"/>`),
  },
  {
    id: 'f',
    simbol: svgWrap(`<line x1="25" y1="30" x2="55" y2="30" stroke="#1F2937" stroke-width="3"/><line x1="25" y1="42" x2="55" y2="42" stroke="#1F2937" stroke-width="3"/><line x1="25" y1="54" x2="55" y2="54" stroke="#1F2937" stroke-width="3"/>`),
    kode: svgWrap(`<line x1="24" y1="40" x2="56" y2="40" stroke="#0F766E" stroke-width="6" stroke-linecap="round"/>`),
  },
  {
    id: 'g',
    simbol: svgWrap(`<circle cx="24" cy="40" r="6" fill="none" stroke="#1F2937" stroke-width="3"/><line x1="30" y1="40" x2="50" y2="40" stroke="#1F2937" stroke-width="3"/><circle cx="56" cy="40" r="6" fill="none" stroke="#1F2937" stroke-width="3"/>`),
    kode: svgWrap(`<path d="M22,42 L34,54 L58,26" fill="none" stroke="#15803D" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>`),
  },
  {
    id: 'h',
    simbol: svgWrap(`<path d="M28,20 V50 H55" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`),
    kode: svgWrap(`<polygon points="40,18 62,40 40,62 18,40" fill="none" stroke="#BE185D" stroke-width="5"/>`),
  },
  {
    id: 'i',
    simbol: svgWrap(`<path d="M40,50 a10,10 0 1,1 10,-10 a18,18 0 1,1 -18,18" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round"/>`),
    kode: svgWrap(`<circle cx="30" cy="40" r="6" fill="#374151"/><circle cx="50" cy="40" r="6" fill="#374151"/>`),
  },
  {
    id: 'j',
    simbol: svgWrap(`<path d="M22,50 L40,22 L58,50" fill="none" stroke="#1F2937" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`),
    kode: svgWrap(`<path d="M40,18 L46,34 L63,34 L49,44 L54,60 L40,50 L26,60 L31,44 L17,34 L34,34 Z" fill="none" stroke="#CA8A04" stroke-width="4" stroke-linejoin="round"/>`),
  },
];

// ─── HELPER FUNCTIONS ─────────────────────────────────────────

// Bangun urutan soal acak sepanjang n item, tiap item merujuk salah
// satu dari 10 kunci (id a-j). Dijamin tidak ada 2 simbol sama persis
// berturut-turut (biar tidak terasa "diam" / mudah ditebak tanpa lihat).
export function generateUrutanSoal(n = 80) {
  const ids = kunciSimbol.map(k => k.id);
  const hasil = [];
  let last = null;
  for (let i = 0; i < n; i++) {
    let pilihan;
    do {
      pilihan = ids[Math.floor(Math.random() * ids.length)];
    } while (pilihan === last && ids.length > 1);
    last = pilihan;
    hasil.push({ id: `SUB-${i + 1}`, kunciId: pilihan });
  }
  return hasil;
}

export function hitungSkorSubstitusi(soalList, jawabanUser) {
  let benar = 0, salah = 0, kosong = 0;
  soalList.forEach(soal => {
    const jwb = jawabanUser.find(j => j.id === soal.id)?.jawaban;
    if (!jwb) kosong++;
    else if (jwb === soal.kunciId) benar++; else salah++;
  });
  const dikerjakan = benar + salah;
  return {
    benar, salah, kosong, total: soalList.length, dikerjakan,
    skor: dikerjakan === 0 ? 0 : Math.round((benar / dikerjakan) * 100),
  };
}
